import React from "react";
import "./DataHolder.scss";

export const ProgressPercentageComponent = ({ percentageValue, changeInValue }) => {
    let showThisValue;
    if (changeInValue > 0) {
        showThisValue = (
            <div className="positive_percentage_progress" style={{display:"flex"}}>
                 <div style={{width:"20%",marginTop:"9%",marginLeft:"19%"}}>
                    <svg width="20" height="13" viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.76918 0L0.215332 9L3.79802 12.375L9.76918 6.75L15.7403 12.375L19.323 9L9.76918 0Z" fill="#51617D"/>
                    </svg>
                </div>

                <p style={{color:'#51617D',width:"50%"}}>{percentageValue}</p>
            </div>
        );
    } else if (changeInValue < 0) {
        showThisValue = (
            <div className="negative_percentage_progress" style={{display:"flex"}}>
                <div style={{width:"20%",marginTop:"9%",marginLeft:"19%"}}>
                    <svg width="20" height="13" viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.79802 0L0.215332 3.375L9.76918 12.375L19.323 3.375L15.7403 0L9.76918 5.625L3.79802 0Z" fill="white"/>
                    </svg>
                </div>

                {/* <img src={NegativeIcon} height="18px" width="20px" background="#FFFFFF" /> */}
                <p style={{color: '#FFFFFF',width:"50%"}}>{percentageValue}</p>
            </div>
        );
    } else {
        showThisValue = (
            <div className="neutral_percentage_progress" style={{display:"flex"}}>
                <div style={{marginTop:"9%",marginLeft:"40%"}}>
                    <svg width="21" height="4" viewBox="0 0 21 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="21" height="4" fill="#B6BED1"/>
                    </svg>
                </div>
                {/* <p style={{width:"50%"}}>{percentageValue}</p> */}
            </div>
        );    }
    return <div className="centeralign">{showThisValue}</div>;





};
